import axios from 'axios';

export const baseURL =
  process.env.REACT_APP_API_URL ?? 'https://cjs-dev-api.na.amisbyte.com/api/';
// process.env.REACT_APP_API_URL ?? "https://api-ws.srisailadevasthanam.org/";

const Axios = axios.create({
  baseURL: baseURL,
});

Axios.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
    if (!config.headers['X-Temple-Id']) {
      config.headers['X-Temple-Id'] = localStorage.getItem('templeId');
    }
  }
  return config;
});

// var fetchCycle = false;
Axios.interceptors.response.use(
  (response) => response,
  async (error, obj) => {
    const originalRequest = error.config;

    if (error.message === 'Network Error') {
      localStorage.clear();
      return Promise.reject(error);
    }
    // Prevent infinite loops
    console.log({ error: error, obj });
    if (
      error.response.status === 401 &&
      (originalRequest.url === 'v1/user/refresh' ||
        originalRequest.url === 'v1/user/login' ||
        originalRequest.url === 'v1/user/logout')
    ) {
      if (originalRequest.url === 'v1/user/logout') {
        localStorage.clear();
        return Promise.resolve();
      }
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        // if (refreshToken && !fetchCycle) {
        // fetchCycle = true;
        try {
          const resp = await Axios.post(
            'v1/user/refresh',
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('refreshToken')}`,
                'X-Temple-Id': localStorage.getItem('templeId'),
              },
            }
          );
          console.log(resp);
          localStorage.setItem('accessToken', resp.data.accessToken);

          originalRequest.headers[
            'Authorization'
          ] = `Bearer ${localStorage.getItem('accessToken')}`;
          // fetchCycle = false;
          return Axios(originalRequest);
        } catch (e) {
          // fetchCycle = false;
          if (error.response.status === 401) {
            localStorage.clear();
            return Promise.reject(error);
          }
        }
      } else {
        return Promise.reject(error);
      }
    }
    // specific error handling done elsewhere
    return Promise.reject(error);
  }
);

export default Axios;
